import React from 'react';
import { Button } from 'react-bootstrap';
import { toothConditions } from '../dentist/data/teethData';

const Tooth = ({ tooth, condition = 'healthy', isSelected, bulkMode, onClick, onAddTreatmentPlan }) => {
	const getToothColor = (condition) => {
		const found = toothConditions.find(tc => tc.value === condition);
		return found ? found.color : '#ffffff';
	};

	const getToothShape = (type) => {
		switch (type) {
			case 'incisor': return 'M10,5 L30,5 L35,25 L25,35 L15,35 L5,25 Z';
			case 'canine': return 'M10,5 L30,5 L35,20 L30,40 L20,45 L10,40 L5,20 Z';
			case 'premolar': return 'M8,8 L32,8 L38,15 L38,30 L32,37 L8,37 L2,30 L2,15 Z';
			case 'molar': return 'M5,10 L35,10 L40,15 L40,35 L35,40 L5,40 L0,35 L0,15 Z';
			default: return 'M10,10 L30,10 L35,35 L5,35 Z';
		}
	};

	return (
		<div className="tooth-container text-center mb-2">
			<div
				className={`tooth ${isSelected ? 'selected' : ''}`}
				onClick={() => onClick && onClick(tooth)}
				style={{ cursor: 'pointer' }}
				title={`${tooth.name} (${tooth.number})`}
			>
				<svg width="45" height="50" viewBox="0 0 40 45">
					<path
						d={getToothShape(tooth.type)}
						fill={getToothColor(condition)}
						stroke={isSelected ? '#0066cc' : '#333'}
						strokeWidth={isSelected ? '3' : '1.5'}
						className="tooth-svg"
					/>
					{bulkMode && isSelected && (
						<>
							<circle
								cx="35"
								cy="5"
								r="8"
								fill="#28a745"
								stroke="#ffffff"
								strokeWidth="2"
							/>
							<text
								x="35"
								y="9"
								textAnchor="middle"
								fill="white"
								fontSize="10"
								fontWeight="bold"
							>
								✓
							</text>
						</>
					)}
				</svg>
				<div className="tooth-number">
					<small className="fw-bold">{tooth.number}</small>
				</div>
			</div>

			{isSelected && !bulkMode && (
				<div className="condition-selector mt-2">
					<Button type="button" variant="primary" size="sm" className="mt-2 w-100" onClick={() => onAddTreatmentPlan && onAddTreatmentPlan(tooth)}>
						New Tx
					</Button>
				</div>
			)}
		</div>
	);
};

export default Tooth;